import React, { type SyntheticEvent, useState } from 'react'

import {
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
} from "@mui/material";
import SearchField from "../../../components/SearchField/SearchField";
import {
  SearchResult,
  SearchSchoolDistrictContainerProps,
} from "../../../types/types";
import { useLazySearchHigschoolwithagnacyNameQuery } from "../api/highSchoolApiSlice";
import { HighSchool } from "../types/types";
// type SearchHigSchoolProps = {
//   term: string;
//   agancyName: string;
//   schoolDistrictID?: Partial<HighSchool> | null;
// };
const SearchHighSchool: React.FC<
SearchSchoolDistrictContainerProps<HighSchool> & {
  agancyName: string
  schoolDistrictID?: Partial<HighSchool> | null
}
> = ({ onChangeState, agancyName, schoolDistrictID }) => {
  const [options, setOptions] = useState<SearchResult[]>([]);
  const [searchHigschoolwithagnacyName, { isLoading,  }] =
    useLazySearchHigschoolwithagnacyNameQuery();

  const onFetch = async (
    event: SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ) => {
    try {
      const newOptions = await searchHigschoolwithagnacyName({
        term: value || ' ',
        agancyName
      }).unwrap()

      setOptions(newOptions);
    } catch (error) {
      console.error(error)
    }
  };

  const onChagneHandler = (
    event: SyntheticEvent<Element, Event>,
    value: SearchResult | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value?.id) {
      onChangeState({ _id: value.id, school_name: value.label })
    }
  }

  return (
    <>
      <SearchField
        options={options}
        loading={isLoading}
        handleInputChange={onFetch}
        onChangeHandle={onChagneHandler}
        schoolDistrictID={schoolDistrictID}
      />
    </>
  )
}

export default SearchHighSchool
